export enum CheckboxListDirection {
  Row = 'row',
  Column = 'column'
}
